import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Events, Platform } from 'ionic-angular';
import * as _ from 'lodash';
import { BranchIo } from '@ionic-native/branch-io';
import { StorageServiceProvider } from '../storage-service/storage-service';
import * as moment from 'moment';

const win: any = window;

@Injectable()
export class UtilsServiceProvider {
  public isDevice: boolean = false;
  public isX: boolean = false;
  constructor(
    private domSanitizer: DomSanitizer,
    private branch: BranchIo,
    public events: Events,
    public plt: Platform,
    public storageService: StorageServiceProvider
  ) {}

  getBase64FromFile(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = error => {
        reject(error);
      };
    });
  }

  makeTrustedImage(base64Image) {
    if (base64Image) {
      const imageString = JSON.stringify(base64Image).replace(/\\n/g, '');
      const style = 'url(' + imageString + ')';
      return this.domSanitizer.bypassSecurityTrustStyle(style);
    } else {
      return null;
    }
  }

  sanitize(base64Image) {
    if (base64Image) {
      return this.domSanitizer.bypassSecurityTrustUrl(base64Image);
    } else {
      return null;
    }
  }

  isFirefox() {
    window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1 ||
      window.navigator.userAgent.toLowerCase().indexOf('edge') > -1;
  }

  /**
   * Format time ago to show in slider
   *
   * @param {date} item
   * @returns
   * @memberof UtilsServiceProvider
   */
  formatTimeAgo(date) {
    return moment(date).fromNow();
  }

  removeClass(elem, className) {
    if (elem && className) {
      var newClass = ' ' + elem.className.replace(/[\t\r\n]/g, ' ') + ' ';
      if (this.hasClass(elem, className)) {
        while (newClass.indexOf(' ' + className + ' ') >= 0) {
          newClass = newClass.replace(' ' + className + ' ', ' ');
        }
        elem.className = newClass.replace(/^\s+|\s+$/g, '');
      }
    }
  }

  hasClass(elem, className) {
    return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
  }

  addClass(elem, className) {
    if (!this.hasClass(elem, className)) {
      elem.className += ' ' + className;
    }
  }

  setDevice(isX) {
    this.isDevice = true;
    this.isX = isX;
  }

  handleBranch() {
    if (this.plt.is('cordova')) {
      this.branch.initSession().then(data => {
        if (data['+clicked_branch_link']) {
          this.events.publish('publicAsk', {
            id: data.canonicalIdentifier.split('/')[1]
          });
        }
      });
    }
  }

  handleBranchWeb() {
    if (!this.plt.is('cordova')) {
      const events = this.events;
      const jwt = this.storageService.getStorage('JWTToken');

      win.branch.data((err, data) => {
        if (err === null) {
          if (_.get(data, 'data_parsed.canonicalIdentifier')) {
            if (jwt) {
              events.publish('publicAskRegisteredUser', {
                id: data.data_parsed.canonicalIdentifier.split('/')[1]
              });
            } else {
              events.publish('publicAsk', {
                id: data.data_parsed.canonicalIdentifier.split('/')[1]
              });
            }
          }
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/utils-service/utils-service.ts